module.exports = __webpack_public_path__ + "img/20200809-1.29595304.png";